import { useMutationCommon } from "hooks/useCRUD";
import formatDataService from "services/FormatDataService";

// Thay thế chứng từ
export const useReplaceTaxDeduct = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: formatDataService.replaceTaxDeducts,
    onSuccess,
    onError,
    translation: ["taxDeduct"],
    translationAction: "replaceTaxDeducts",
    target: "taxDeducts",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Điều chỉnh chứng từ
export const useAdjustTaxDeduct = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: formatDataService.adjustTaxDeducts,
    onSuccess,
    onError,
    translation: ["taxDeduct"],
    translationAction: "adjustTaxDeducts",
    target: "taxDeducts",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Phát hành chứng từ
export const useReleaseTaxDeduct = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: formatDataService.releaseTaxDeducts,
    onSuccess,
    onError,
    translation: ["taxDeduct"],
    translationAction: "releaseTaxDeducts",
    target: "taxDeducts",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Lấy thông tin liên kết chứng từ
export const useGetLinkTaxDeduct = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: formatDataService.getDataLinkTaxDeduct,
    onSuccess,
    onError,
    translation: ["taxDeduct"],
    translationAction: "getDataLinkTaxDeduct",
    target: "taxDeducts",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Thay thế chứng từ
export const useGetParentBuTaxDeduct = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: formatDataService.getParentBuTaxDeduct,
    onSuccess,
    onError,
    translation: ["taxDeduct"],
    translationAction: "getParentBuTaxDeduct",
    target: "taxDeducts",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};
